// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"a8f1d3d8","977":"41649a14"}[chunkId] + ".chunk.js";
};